module.exports = __webpack_public_path__ + "img/frontView.1fcdef63.png";